/**
 * Backwards-compatible useAuth() shim — backed by Redux.
 * All existing code calling useAuth() continues to work:
 *   const [auth, setAuth] = useAuth();
 * setAuth({ user, token }) dispatches to Redux + persists to storage.
 * setAuth({ user: null, token: "" }) clears credentials.
 */
import { createContext, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials, clearCredentials, selectAuth } from "../store/authSlice";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => children;

const useAuth = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  const setAuth = (value) => {
    if (!value || (!value.user && !value.token)) {
      dispatch(clearCredentials());
      return;
    }
    dispatch(
      setCredentials({
        user: value.user,
        token: value.token,
        rememberMe: !!localStorage.getItem("auth"),
      })
    );
  };

  return [auth, setAuth];
};

export { useAuth };
